<template>
  <div>
    <div class="q-pa-md">
      <q-card class="my-card" flat bordered>
        <q-item>
          <q-item-section avatar>
            <q-icon name="people" />
          </q-item-section>
          <q-item-section>
            <q-item-label>Danisan</q-item-label>
          </q-item-section>
        </q-item>
        <q-separator />
        <q-card-section horizontal>
          <q-card-section>
            <div class="col-2 q-pa-md">
              <CustomerPurchase :customer-id="customer.id" />
            </div>
            <div class="col-2 q-pa-md">
              <CreateCustomerNote :customer-id="customer.id" />
            </div>
          </q-card-section>
          <q-separator vertical />
          <q-card-section class="col-4">
            Bu sayfadan danisan yonetebilirsiniz.
          </q-card-section>
        </q-card-section>
      </q-card>
    </div>
    <div class="row q-pa-md">
      <div class="col-12">
        <q-card flat bordered>
          <q-card-section horizontal>
            <q-card-section>
              <div class="text-h5">{{ customer.name }}</div>
            </q-card-section>
          </q-card-section>
          <div class="row">
            <div class="col-12">
              <CustomerInfo :customer="customer" />
            </div>
          </div>
          <q-separator />
          <div class="row">
            <div class="col-xs-12 col-sm-4">
              <CustomerNotes :customer-id="customer.id" />
            </div>
            <div class="col-xs-12 col-sm-4">
              <CustomerPayments :customer-id="customer.id" />
            </div>
            <div class="col-xs-12 col-sm-4">
              <CustomerAppointments :customer-id="customer.id" />
            </div>
          </div>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, inject } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import CustomerInfo from '../components/customer/Info.vue'
import CustomerPurchase from '../components/customer/Purchase.vue'
import CustomerNotes from '../components/customer/Notes.vue'
import CustomerPayments from '../components/customer/Payments.vue'
import CustomerAppointments from '../components/customer/Appointments.vue'
import CreateCustomerNote from '../components/notes/Create.vue'
import * as eventNames from '../utils/events'

export default {
  components: {
    CustomerInfo,
    CustomerPurchase,
    CustomerNotes,
    CustomerPayments,
    CustomerAppointments,
    CreateCustomerNote,
  },
  setup() {
    const route = useRoute()
    const customer = ref({})

    const emitter = inject('emitter')
    emitter.on(eventNames.REFRESH_CUSTOMER, () => {
      getCustomer()
    })

    function getCustomer() {
      const customerId = route.path.split('/').pop()
      axios.get(`/customers/${customerId}`).then((response) => {
        customer.value = response.data
      })
    }

    getCustomer()

    return {
      customer,
    }
  },
}
</script>
